// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



/* CSS FOR BOTTOM CLASS */











/* ================================
   SCADA WTP RESPONSIVE CSS
================================ */

.scada-wrapper {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

/* Main footer/table container */
.map-footer {
  width: 100%;
  box-sizing: border-box;
}

/* Main card */
.scada-main-card {
  width: 99%;
  max-width: 100%;
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}

/* ================================
   HEADER
================================ */

.scada-header {
  width: 100%;
  background: linear-gradient(135deg, #0f6d86, #0b5f68);
  padding: 12px 18px;
  box-sizing: border-box;
  color: #fff;
}

.scada-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

/* Header left / center / right */
.scada-header-left,
.scada-header-center,
.scada-header-right {
  flex: 1 1;
  min-width: 0;
}

.scada-header-left {
  display: flex;
  justify-content: center;
}

.scada-header-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scada-header-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* ================================
   KPI CARDS
================================ */

.scada-kpi-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
}

.scada-kpi-card {
  width: 95px;
  min-width: 80px;
  height: 50px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}

.scada-kpi-title {
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  line-height: 12px;
}

.scada-kpi-value {
  font-size: 18px;
  font-weight: 700;
  margin-top: 3px;
}

/* ================================
   LOGO
================================ */

.scada-logo-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.scada-logo {
  width: 55px;
  height: 55px;
  object-fit: contain;
}

.scada-title {
  text-align: center;
}

.scada-title h6 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}

.scada-title h6:last-child {
  margin-top: 3px;
  font-size: 14px;
  font-weight: 500;
}

/* ================================
   BUTTONS
================================ */

.scada-action-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.scada-action-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

/* ================================
   TABLE SECTION
================================ */

.scada-table-wrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  background: #fff;
  border-radius: 0 0 8px 8px;
  -webkit-overflow-scrolling: touch;
}

.scada-table-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
}

.main-table {
  width: 100%;
  min-width: 1200px;
  border-collapse: collapse;
  table-layout: auto;
}

.main-table th {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f2f2f2;
  white-space: nowrap;
}

.main-table td,
.main-table th {
  padding: 8px 10px;
  font-size: 12px;
  border: 1px solid #ddd;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

/* ================================
   FILTER BAR
================================ */

.scada-filter-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  background: linear-gradient(90deg, #116d86, #0b6868);
  padding: 10px 12px;
  border-radius: 10px;
  margin-bottom: 12px;
  color: #fff;
}

.scada-filter-section {
  flex: 1 1;
  min-width: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.scada-filter-select {
  padding: 6px 10px;
  border-radius: 6px;
  border: none;
  outline: none;
  font-size: 13px;
  cursor: pointer;
  max-width: 100%;
}

.scada-search-container {
  position: relative;
  width: 250px;
  max-width: 100%;
}

.scada-search {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 32px 7px 10px;
  border-radius: 6px;
  border: none;
  outline: none;
}

.scada-record-count {
  flex: 1 1;
  min-width: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
}

.scada-record-count h6 {
  color: #ffd700;
  font-weight: 700;
  margin: 0;
}

/* ================================
   MAXIMIZED TABLE
================================ */

.map-footer.table-maximized {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: rgba(15, 23, 42, 0.96);
  padding: 10px;
  box-sizing: border-box;
}

.table-maximized .scada-main-card {
  width: 100%;
  height: 100%;
}

.table-maximized .scada-table-wrapper {
  max-height: calc(100vh - 160px);
}

/* ================================
   LARGE TABLET
================================ */

@media (max-width: 1200px) {

  .scada-header-row {
    gap: 12px;
  }

  .scada-header-left,
  .scada-header-center,
  .scada-header-right {
    flex: 1 1 30%;
  }

  .scada-kpi-card {
    width: 85px;
    height: 48px;
  }

  .scada-kpi-title {
    font-size: 9px;
  }

  .scada-kpi-value {
    font-size: 16px;
  }

  .scada-title h6 {
    font-size: 14px;
  }

  .scada-title h6:last-child {
    font-size: 12px;
  }

  .scada-action-btn {
    padding: 7px 10px;
    font-size: 12px;
  }
}

/* ================================
   TABLET
================================ */

@media (max-width: 900px) {

  .scada-header {
    padding: 10px;
  }

  .scada-header-row {
    flex-direction: column;
    align-items: stretch;
  }

  .scada-header-left,
  .scada-header-center,
  .scada-header-right {
    width: 100%;
    min-width: 100%;
    flex: none;
  }

  .scada-header-left {
    order: 2;
  }

  .scada-header-center {
    order: 1;
  }

  .scada-header-right {
    order: 3;
    justify-content: center;
  }

  .scada-kpi-container {
    gap: 8px;
  }

  .scada-kpi-card {
    width: 100px;
  }

  .scada-action-buttons {
    justify-content: center;
  }

  .scada-filter-section {
    min-width: 45%;
  }

  .scada-record-count {
    min-width: 100%;
  }
}

/* ================================
   MOBILE
================================ */

@media (max-width: 600px) {

  .scada-main-card {
    width: 100%;
    border-radius: 0;
  }

  .scada-header {
    padding: 8px;
  }

  .scada-logo-section {
    flex-direction: column;
    gap: 5px;
  }

  .scada-logo {
    width: 45px;
    height: 45px;
  }

  .scada-title h6 {
    font-size: 12px;
    line-height: 16px;
  }

  .scada-title h6:last-child {
    font-size: 11px;
  }

  .scada-kpi-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
    padding: 5px;
  }

  .scada-kpi-card {
    width: 100%;
    height: 52px;
  }

  .scada-kpi-title {
    font-size: 9px;
  }

  .scada-kpi-value {
    font-size: 17px;
  }

  .scada-action-buttons {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
  }

  .scada-action-btn {
    width: 100%;
    padding: 9px;
    font-size: 12px;
  }

  .scada-filter-bar {
    flex-direction: column;
    padding: 8px;
  }

  .scada-filter-section {
    width: 100%;
    min-width: 100%;
    justify-content: flex-start;
  }

  .scada-filter-select {
    flex: 1 1;
    width: 100%;
  }

  .scada-search-container {
    width: 100%;
  }

  .scada-record-count {
    width: 100%;
    min-width: 100%;
    font-size: 15px;
  }

  .scada-table-wrapper {
    max-height: 60vh;
  }

  .main-table {
    min-width: 1200px;
  }

  .main-table th,
  .main-table td {
    padding: 7px 8px;
    font-size: 11px;
  }
}

/* ================================
   SMALL MOBILE
================================ */

@media (max-width: 400px) {

  .scada-kpi-container {
    grid-template-columns: repeat(2, 1fr);
  }

  .scada-kpi-card {
    height: 48px;
  }

  .scada-kpi-title {
    font-size: 8px;
  }

  .scada-kpi-value {
    font-size: 15px;
  }

  .scada-title h6 {
    font-size: 11px;
  }

  .scada-title h6:last-child {
    font-size: 10px;
  }

  .main-table th,
  .main-table td {
    font-size: 10px;
    padding: 6px;
  }
}

/* ================================
   SCROLLBAR
================================ */

.scada-table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.scada-table-wrapper::-webkit-scrollbar-track {
  background: #e5e7eb;
  border-radius: 10px;
}

.scada-table-wrapper::-webkit-scrollbar-thumb {
  background: #0f6d86;
  border-radius: 10px;
}

.scada-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #0b5f68;
}


/*  CODE FOR  BOTTOM LAYERS */










.dashboardWTP {
  position: relative;
  padding-top: 20px;;
  z-index: 1;
  height:90vh;
  display: grid;
  grid-template-rows: 78px 1fr;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
  backdrop-filter: blur(20px);
}

.brand {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 310px;
}

.brand-icon {
  width: 50px;
  height: 50px;
  display: grid;
  place-items: center;
  border-radius: 14px;

  box-shadow: 0 0 30px rgba(34, 211, 238, 0.24);
}

.brand-icon svg,
.mini-icon svg,
.node-icon svg {
  width: 40px;
  height: 40px;
  color: white;
}

h1 {
  font-size: clamp(19px, 2.4vw, 29px);
  line-height: 1.05;
  letter-spacing: 0;
}

.subline {
  color: var(--muted);
  font-size: 13px;
  margin-top: 6px;
}

.top-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.control1,
.status-pill {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: 1px solid var(--border);
  background: rgba(6, 29, 52, 0.055);
  border-radius: 8px;
  color: var(--text);
}

.control1 {
  position: relative;
  padding: 0 14px;
}

.control1 svg,
.status-pill svg {
  width: 18px;
  height: 18px;
  color: var(--cyan);
}

.selectwtp {
  min-width: 210px;
  padding-right: 20px;
  border: 0;
  outline: 0;
  appearance: none;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}

option {
  background: #9aa3ad;
  color: var(--text);
}

.control1::after {
  content: "";
  width: 8px;
  height: 8px;
  border-right: 2px solid var(--muted);
  border-bottom: 2px solid var(--muted);
  transform: rotate(45deg);
  position: absolute;
  right: 14px;
  top: 14px;
  pointer-events: none;
}

.status-pill {
  padding: 0 13px;
  color: #c9edf8;
  font-size: 13px;
}

.pulse {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6);
  animation: pulse 1.7s infinite;
}

.main {
  min-height: 0;
  display: grid;
  grid-template-columns: 288px minmax(620px, 1fr) 330px;
  gap:0px;
  padding: 0px;
}

.rail,
.right-panel,
.map-panel {
  min-height: 0;
  border: 1px solid var(--border);
  border-radius: 10px;
  background:rgb(25, 34, 36);
  backdrop-filter: blur(20px);
  box-shadow: var(--shadow);
}

.rail,
.right-panel {
  overflow: auto;
}



.panel-title {
  font-size: 13px;
  color: #c7e8f5;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.tiny {
  color: var(--muted);
  font-size: 12px;
}

.kpis {
  display: grid;
  gap: 5px;
  padding: 10px;
}

.kpi {
  position: relative;
  min-height:10px;
  padding: 10px;
  overflow: hidden;
  border: 1px solid rgba(20, 23, 24, 0.12);
  border-radius: 8px;
  background:rgb(5, 34, 63);
   
}

.kpi::after {
  content: "";
  position: absolute;
  width:20px;
  height: 110px;
  right: -52px;
  bottom: -56px;
  border-radius: 50%;  
 background: color-mix(in srgb, var(--accent) 18%, transparent);
}

.kpi-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.mini-icon {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 8px;
  color: var(--accent);
  background: color-mix(in srgb, var(--accent) 13%, transparent);
}

.kpi-value {
  margin-top: 12px;
  font-size: 33px;
  font-weight: 850;
  letter-spacing: 0;
}

.kpi-caption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  color: #a9c4d5;
  font-size: 12px;
}

.trend {
  color: var(--green);
  font-weight: 800;
}

.system-box {
  margin: 0 14px 14px;
  padding: 14px;
  border: 1px solid rgba(148, 219, 255, 0.12);
  border-radius: 8px;
  background: rgba(255,255,255,0.035);
}

.ring {
  width: 138px;
  height: 138px;
  margin: 10px auto 8px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background:
    conic-gradient(var(--green) 0deg, var(--cyan) var(--health-angle), rgba(255,255,255,0.08) 0deg),
    radial-gradient(circle, rgba(7,16,24,1) 58%, transparent 59%);
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.08), 0 0 32px rgba(34, 211, 238, 0.12);
}

.ring-inner {
  width: 98px;
  height: 98px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #0a1722;
  border: 1px solid rgba(148, 219, 255, 0.12);
  text-align: center;
}

.ring-value {
  font-size: 27px;
  font-weight: 850;
}

.ring-label {
  color: var(--muted);
  font-size: 11px;
  margin-top: 3px;
}

.mini-bars {
  display: grid;
  gap: 9px;
  margin-top: 12px;
}

.mini-bar {
  display: grid;
  grid-template-columns: 82px 1fr 38px;
  align-items: center;
  gap: 9px;
  color: #bad4e3;
  font-size: 12px;
}

.bar-track {
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(255,255,255,0.08);
}

.bar-fill {
  width: var(--w);
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--blue), var(--teal));
  animation: barBreathe 2.6s ease-in-out infinite;
}

.map-panel {
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-rows: auto 1fr auto;
}

.map-toolbar {
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(148, 219, 255, 0.12);
}

.map-title {
  display: flex;
  align-items: center;
  gap: 10px;

}

.map-title strong {
  font-size: 16px;
}

.map-title span {
  display: block;
  margin-top: 3px;
  color: var(--muted);
  font-size: 12px;
}

.segmented {
  display: inline-flex;
  padding: 4px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: rgba(255,255,255,0.04);
}

.segment {
  border: 0;
  color: var(--muted);
  background: transparent;
  padding: 8px 11px;
  border-radius: 6px;
  font: inherit;
  font-size: 12px;
  font-weight: 800;
}

.segment.active {
  color: #071018;
  background: linear-gradient(135deg, var(--cyan), var(--green));
}

.canvas-wrap {
  position: relative;
  overflow: auto;
  scrollbar-color: rgba(56, 189, 248, 0.45) rgba(255,255,255,0.05);
}

.network {
  position: relative;
  min-width: 1320px;
  min-height: 780px;
  overflow: visible;
  background:
    linear-gradient(90deg, rgba(56, 189, 248, 0.045), transparent 31%, transparent 67%, rgba(251, 191, 36, 0.045)),
    radial-gradient(circle at 50% 46%, rgba(34, 211, 238, 0.08), transparent 34rem);
}

.lane {
  position: absolute;
  top: 18px;
  height: 28px;
  padding: 6px 10px;
  border: 1px solid rgba(148, 219, 255, 0.13);
  border-radius: 999px;
  color: #b9dceb;
  background: rgba(255,255,255,0.045);
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.08em;
}

.lane-intake { left: 66px; }
.lane-wtp { left: 528px; }
.lane-oht { left: 1016px; }

#svgCanvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
}

.pipe-shadow {
  fill: none;
  stroke: rgba(0, 0, 0, 0.34);
  stroke-width: 17;
  stroke-linecap: round;
}

.pipe-base {
  fill: none;
  stroke: rgba(148, 219, 255, 0.16);
  stroke-width: 9;
  stroke-linecap: round;
}

.pipe-flow {
  fill: none;
  stroke: url(#pipeGradient);
  stroke-width: 6;
  stroke-linecap: round;
  stroke-dasharray: 14 17;
  animation: pipeFlow 0.76s linear infinite;
  filter: drop-shadow(0 0 9px rgba(34, 211, 238, 0.62));
}

.drop {
  fill: #e0faff;
  stroke: #38bdf8;
  stroke-width: 2;
  filter: drop-shadow(0 0 10px rgba(34, 211, 238, 0.82));
}

.node {
  position: absolute;
  z-index: 4;
  width: 188px;
  min-height: 108px;
  padding: 13px;
  border: 1px solid rgba(148, 219, 255, 0.18);
  border-top-color: color-mix(in srgb, var(--accent) 62%, white);
  border-radius: 9px;
  background:
    linear-gradient(145deg, color-mix(in srgb, var(--accent) 12%, transparent), rgba(255,255,255,0.045)),
    rgba(9, 22, 34, 0.92);
  box-shadow: 0 18px 42px rgba(0,0,0,0.34);
  overflow: hidden;
  animation: nodeFloat 5s ease-in-out infinite;
  transition: transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease;
}

.node::after {
  content: "";
  position: absolute;
  width: 90px;
  height: 90px;
  right: -38px;
  bottom: -42px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--accent) 16%, transparent);
}

.node:hover {
  transform: translateY(-6px);
  border-color: color-mix(in srgb, var(--accent) 70%, white);
  box-shadow: 0 26px 58px rgba(0,0,0,0.44), 0 0 22px color-mix(in srgb, var(--accent) 18%, transparent);
}

.node-main {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.node-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #06111a;
  background: linear-gradient(135deg, var(--accent), color-mix(in srgb, var(--accent) 55%, white));
  flex: 0 0 auto;
}

.node-name {
  font-size: 15px;
  font-weight: 850;
  text-transform: uppercase;
  letter-spacing: 0;
}

.node-type {
  color: var(--muted);
  margin-top: 3px;
  font-size: 18px;
  line-height: 1.35;
  color:#b9dceb
}

.node-data {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.meter {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255,255,255,0.1);
}

.meter span {
  display: block;
  height: 100%;
  width: var(--level);
  border-radius: inherit;
  background: linear-gradient(90deg, var(--accent), #e0faff);
  animation: barBreathe 2.4s ease-in-out infinite;
}

.flow-text {
  color: #e6fbff;
  font-size: 12px;
  font-weight: 850;
  white-space: nowrap;
}

.node-foot {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  color: var(--muted);
  font-size: 11px;
}

.ok {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #a7f3d0;
  font-weight: 800;
}

.ok::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 10px rgba(34, 197, 94, 0.8);
}

.intake { --accent: var(--blue); }
.wtp { --accent: var(--teal); }
.oht { --accent: var(--amber); }

.flow-card {
  position: absolute;
  z-index: 6;
  min-width: 92px;
  padding: 7px 9px;
  border: 1px solid rgba(56, 189, 248, 0.22);
  border-radius: 8px;
  background: rgba(4, 13, 22, 0.9);
  box-shadow: 0 14px 30px rgba(0,0,0,0.28);
  text-align: center;
  animation: cardIn 360ms ease both;
}

.flow-card small {
  display: block;
  color: var(--muted);
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.08em;
}

.flow-card strong {
  display: block;
  color: var(--cyan);
  margin-top: 2px;
  font-size: 13px;
}

.map-footer {
    min-height: 150px;
  display: grid;

}

.footer-stat {
  min-height: 74px;
  padding: 12px 14px;
  background: rgba(7, 16, 24, 0.72);
}

.footer-stat span {
  color: var(--muted);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.footer-stat strong {
  display: block;
  margin-top: 6px;
  font-size: 22px;
}

.alerts,
.assets {
  padding: 3px;
  display: grid;
  gap: 10px;
}

.alert {
  display: grid;
  grid-template-columns: 10px 1fr auto;
  gap: 10px;
  align-items: start;
  padding: 12px;
  border: 1px solid rgba(148, 219, 255, 0.12);
  border-radius: 8px;
  background: rgba(255,255,255,0.04);
}

.severity {
  width: 10px;
  height: 10px;
  margin-top: 4px;
  border-radius: 50%;
  background: var(--sev);
  box-shadow: 0 0 14px color-mix(in srgb, var(--sev) 75%, transparent);
}

.alert strong {
  display: block;
  font-size: 13px;
}

.alert span {
  display: block;
  margin-top: 3px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.35;
}

.alert time {
  color: #a9c4d5;
  font-size: 11px;
  white-space: nowrap;
}

.asset {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 11px 12px;
  border: 1px solid rgba(148, 219, 255, 0.12);
  border-radius: 8px;
  background: rgba(255,255,255,0.035);
}

.asset strong {
  font-size: 13px;
}

.asset span {
  display: block;
  margin-top: 3px;
  color: var(--muted);
  font-size: 12px;
}

.badge {
  padding: 5px 8px;
  border-radius: 999px;
  color: #071018;
  background: linear-gradient(135deg, var(--cyan), var(--green));
  font-size: 11px;
  font-weight: 850;
}

@keyframes scan {
  from { transform: translateX(-130%); }
  to { transform: translateX(130%); }
}

@keyframes pulse {
  70% { box-shadow: 0 0 0 10px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

@keyframes pipeFlow {
  to { stroke-dashoffset: -31; }
}

@keyframes nodeFloat {
  0%, 100% { translate: 0 0; }
  50% { translate: 0 -4px; }
}

@keyframes barBreathe {
  0%, 100% { opacity: 0.78; }
  50% { opacity: 1; }
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width:900px) {
  body {
    overflow: auto;
  }

  .dashboardWTP {
    min-height: 100vh;
    height: auto;
  }

  .main {
    grid-template-columns: 1fr;
  }



  .kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .map-panel {
    min-height: 720px;
  }
}

@media (max-width: 320px) {
  .topbar {
    align-items: flex-start;
    flex-direction: column;
    height: auto;
  }

  .brand {
    min-width: 0;
  }

  .top-actions,
  .control1 {
    width: 100%;
  }

  selectwtp {
    width: 100%;
    min-width: 0;
  }

  .dashboardWTP {
    grid-template-rows: auto 1fr;
  }

  .kpis,
  .map-footer {
    grid-template-columns: 1fr;
  }

  .map-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
}
/* POPUP Graph  */
.maximized-map-panel {
  position: fixed !important;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(90vw - 80px) !important;
  height: calc(90vh - 80px) !important;
  z-index: 999999;
  border-radius: 20px;
  border: 2px solid rgba(96,165,250,0.55);
  background:
    linear-gradient(
      145deg,
      rgba(0,0,0,0.96),
      rgba(17,24,39,0.94),
      rgba(31,41,55,0.92)
    );

  backdrop-filter: blur(12px);

  overflow: auto;

  padding:
    60px   /* top */
    20px   /* right */
    20px   /* bottom */
    20px;  /* left */

  box-shadow:
    0 0 0 2px rgba(59,130,246,0.15),
    0 10px 40px rgba(0,0,0,0.55),
    0 0 25px rgba(59,130,246,0.25);

  animation: popupZoom 0.28s ease;
}

/* DARK OVERLAY */

.maximized-map-panel::before {
  content: "";
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.68);
  z-index: -1;
}

/* POPUP ANIMATION */

@keyframes popupZoom {

  from {
    opacity: 0;
    transform:
    translate(-50%, -50%)
    scale(0.92);
  }

  to {
    opacity: 1;
    transform:
    translate(-50%, -50%)
    scale(1);
  }
}


.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: Arial, sans-serif;
}

/* HEADER */
.custom-table thead tr {
  background: linear-gradient(to right, #045e5a, #03816c);
}

.custom-table th {
  color: #ffffff;
  text-transform: uppercase;   /* ✅ CAPITAL */
  letter-spacing: 0.5px;       /* ✅ spacing */
  padding: 10px;
  border: 1px solid #0f2a2e;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 2;
}

/* BODY */
.custom-table td {
  padding: 8px;
  border: 1px solid #cfe8f3;
  text-align: center;
}

/* ROW COLORS */
.custom-table tbody tr:nth-child(even) {
  background-color: #f0f9ff;
}

.custom-table tbody tr:nth-child(odd) {
  background-color: #e0f2fe;
}

/* HOVER EFFECT */
.custom-table tbody tr:hover {
  background-color: #bae6fd;
  transition: 0.2s ease;
}

/* NO DATA ROW */
.custom-table td[colspan] {
  text-align: center;
  font-weight: bold;
  padding: 15px;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/pages/GisTools/scadawtp.css"],"names":[],"mappings":";;;;AAIA,yBAAyB;;;;;;;;;;;;AAYzB;;kCAEkC;;AAElC;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;;kCAEkC;;AAElC;EACE,WAAW;EACX,qDAAqD;EACrD,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,iCAAiC;AACjC;;;EAGE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;;kCAEkC;;AAElC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;kCAEkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;kCAEkC;;AAElC;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;kCAEkC;;AAElC;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;kCAEkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;;kCAEkC;;AAElC;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;kCAEkC;;AAElC;;EAEE;IACE,SAAS;EACX;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;;kCAEkC;;AAElC;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;IAGE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;kCAEkC;;AAElC;;EAEE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,SAAO;IACP,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;;kCAEkC;;AAElC;;EAEE;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;kCAEkC;;AAElC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,6BAA6B;;;;;;;;;;;AAW7B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;EAEnB,6CAA6C;AAC/C;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,qDAAqD;EACrD,OAAO;EACP,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;;;AAIA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;CACnB,8DAA8D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB;;iEAE+D;EAC/D,qFAAqF;AACvF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,4DAA4D;EAC5D,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;AAEX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB;;mFAEiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,eAAe,UAAU,EAAE;AAC3B,YAAY,WAAW,EAAE;AACzB,YAAY,YAAY,EAAE;;AAE1B;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,2CAA2C;EAC3C,8DAA8D;EAC9D,kBAAkB;EAClB;;yBAEuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,4CAA4C;EAC5C,gFAAgF;AAClF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,2BAA2B;EAC3B,0DAA0D;EAC1D,qGAAqG;AACvG;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gGAAgG;EAChG,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,0DAA0D;EAC1D,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA,UAAU,qBAAqB,EAAE;AACjC,OAAO,qBAAqB,EAAE;AAC9B,OAAO,sBAAsB,EAAE;;AAE/B;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;IACI,iBAAiB;EACnB,aAAa;;AAEf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,2BAA2B,EAAE;AACpC;;AAEA;EACE,MAAM,2CAA2C,EAAE;EACnD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;EACE,KAAK,sBAAsB,EAAE;AAC/B;;AAEA;EACE,WAAW,cAAc,EAAE;EAC3B,MAAM,iBAAiB,EAAE;AAC3B;;AAEA;EACE,WAAW,aAAa,EAAE;EAC1B,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;;;EAIA;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;AACA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mCAAmC;EACnC,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC;;;;;;KAMG;;EAEH,2BAA2B;;EAE3B,cAAc;;EAEd;;;;QAIM,GAAG,SAAS;;EAElB;;;kCAGgC;;EAEhC,+BAA+B;AACjC;;AAEA,iBAAiB;;AAEjB;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,WAAW;AACb;;AAEA,oBAAoB;;AAEpB;;EAEE;IACE,UAAU;IACV;;eAEW;EACb;;EAEA;IACE,UAAU;IACV;;YAEQ;EACV;AACF;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,yBAAyB,IAAI,cAAc;EAC3C,qBAAqB,QAAQ,cAAc;EAC3C,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb","sourcesContent":["\n\n\n\n/* CSS FOR BOTTOM CLASS */\n\n\n\n\n\n\n\n\n\n\n\n/* ================================\n   SCADA WTP RESPONSIVE CSS\n================================ */\n\n.scada-wrapper {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n/* Main footer/table container */\n.map-footer {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Main card */\n.scada-main-card {\n  width: 99%;\n  max-width: 100%;\n  margin: 0 auto;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n}\n\n/* ================================\n   HEADER\n================================ */\n\n.scada-header {\n  width: 100%;\n  background: linear-gradient(135deg, #0f6d86, #0b5f68);\n  padding: 12px 18px;\n  box-sizing: border-box;\n  color: #fff;\n}\n\n.scada-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n/* Header left / center / right */\n.scada-header-left,\n.scada-header-center,\n.scada-header-right {\n  flex: 1;\n  min-width: 0;\n}\n\n.scada-header-left {\n  display: flex;\n  justify-content: center;\n}\n\n.scada-header-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.scada-header-right {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* ================================\n   KPI CARDS\n================================ */\n\n.scada-kpi-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.scada-kpi-card {\n  width: 95px;\n  min-width: 80px;\n  height: 50px;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n}\n\n.scada-kpi-title {\n  font-size: 10px;\n  font-weight: 600;\n  text-align: center;\n  line-height: 12px;\n}\n\n.scada-kpi-value {\n  font-size: 18px;\n  font-weight: 700;\n  margin-top: 3px;\n}\n\n/* ================================\n   LOGO\n================================ */\n\n.scada-logo-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.scada-logo {\n  width: 55px;\n  height: 55px;\n  object-fit: contain;\n}\n\n.scada-title {\n  text-align: center;\n}\n\n.scada-title h6 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.scada-title h6:last-child {\n  margin-top: 3px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* ================================\n   BUTTONS\n================================ */\n\n.scada-action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.scada-action-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n/* ================================\n   TABLE SECTION\n================================ */\n\n.scada-table-wrapper {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  overflow-y: auto;\n  background: #fff;\n  border-radius: 0 0 8px 8px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.scada-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: auto;\n}\n\n.main-table {\n  width: 100%;\n  min-width: 1200px;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.main-table th {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: #f2f2f2;\n  white-space: nowrap;\n}\n\n.main-table td,\n.main-table th {\n  padding: 8px 10px;\n  font-size: 12px;\n  border: 1px solid #ddd;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n/* ================================\n   FILTER BAR\n================================ */\n\n.scada-filter-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  background: linear-gradient(90deg, #116d86, #0b6868);\n  padding: 10px 12px;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  color: #fff;\n}\n\n.scada-filter-section {\n  flex: 1;\n  min-width: 220px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.scada-filter-select {\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: none;\n  outline: none;\n  font-size: 13px;\n  cursor: pointer;\n  max-width: 100%;\n}\n\n.scada-search-container {\n  position: relative;\n  width: 250px;\n  max-width: 100%;\n}\n\n.scada-search {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 7px 32px 7px 10px;\n  border-radius: 6px;\n  border: none;\n  outline: none;\n}\n\n.scada-record-count {\n  flex: 1;\n  min-width: 220px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.scada-record-count h6 {\n  color: #ffd700;\n  font-weight: 700;\n  margin: 0;\n}\n\n/* ================================\n   MAXIMIZED TABLE\n================================ */\n\n.map-footer.table-maximized {\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999;\n  background: rgba(15, 23, 42, 0.96);\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.table-maximized .scada-main-card {\n  width: 100%;\n  height: 100%;\n}\n\n.table-maximized .scada-table-wrapper {\n  max-height: calc(100vh - 160px);\n}\n\n/* ================================\n   LARGE TABLET\n================================ */\n\n@media (max-width: 1200px) {\n\n  .scada-header-row {\n    gap: 12px;\n  }\n\n  .scada-header-left,\n  .scada-header-center,\n  .scada-header-right {\n    flex: 1 1 30%;\n  }\n\n  .scada-kpi-card {\n    width: 85px;\n    height: 48px;\n  }\n\n  .scada-kpi-title {\n    font-size: 9px;\n  }\n\n  .scada-kpi-value {\n    font-size: 16px;\n  }\n\n  .scada-title h6 {\n    font-size: 14px;\n  }\n\n  .scada-title h6:last-child {\n    font-size: 12px;\n  }\n\n  .scada-action-btn {\n    padding: 7px 10px;\n    font-size: 12px;\n  }\n}\n\n/* ================================\n   TABLET\n================================ */\n\n@media (max-width: 900px) {\n\n  .scada-header {\n    padding: 10px;\n  }\n\n  .scada-header-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .scada-header-left,\n  .scada-header-center,\n  .scada-header-right {\n    width: 100%;\n    min-width: 100%;\n    flex: none;\n  }\n\n  .scada-header-left {\n    order: 2;\n  }\n\n  .scada-header-center {\n    order: 1;\n  }\n\n  .scada-header-right {\n    order: 3;\n    justify-content: center;\n  }\n\n  .scada-kpi-container {\n    gap: 8px;\n  }\n\n  .scada-kpi-card {\n    width: 100px;\n  }\n\n  .scada-action-buttons {\n    justify-content: center;\n  }\n\n  .scada-filter-section {\n    min-width: 45%;\n  }\n\n  .scada-record-count {\n    min-width: 100%;\n  }\n}\n\n/* ================================\n   MOBILE\n================================ */\n\n@media (max-width: 600px) {\n\n  .scada-main-card {\n    width: 100%;\n    border-radius: 0;\n  }\n\n  .scada-header {\n    padding: 8px;\n  }\n\n  .scada-logo-section {\n    flex-direction: column;\n    gap: 5px;\n  }\n\n  .scada-logo {\n    width: 45px;\n    height: 45px;\n  }\n\n  .scada-title h6 {\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  .scada-title h6:last-child {\n    font-size: 11px;\n  }\n\n  .scada-kpi-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 6px;\n    padding: 5px;\n  }\n\n  .scada-kpi-card {\n    width: 100%;\n    height: 52px;\n  }\n\n  .scada-kpi-title {\n    font-size: 9px;\n  }\n\n  .scada-kpi-value {\n    font-size: 17px;\n  }\n\n  .scada-action-buttons {\n    display: grid;\n    grid-template-columns: 1fr;\n    width: 100%;\n  }\n\n  .scada-action-btn {\n    width: 100%;\n    padding: 9px;\n    font-size: 12px;\n  }\n\n  .scada-filter-bar {\n    flex-direction: column;\n    padding: 8px;\n  }\n\n  .scada-filter-section {\n    width: 100%;\n    min-width: 100%;\n    justify-content: flex-start;\n  }\n\n  .scada-filter-select {\n    flex: 1;\n    width: 100%;\n  }\n\n  .scada-search-container {\n    width: 100%;\n  }\n\n  .scada-record-count {\n    width: 100%;\n    min-width: 100%;\n    font-size: 15px;\n  }\n\n  .scada-table-wrapper {\n    max-height: 60vh;\n  }\n\n  .main-table {\n    min-width: 1200px;\n  }\n\n  .main-table th,\n  .main-table td {\n    padding: 7px 8px;\n    font-size: 11px;\n  }\n}\n\n/* ================================\n   SMALL MOBILE\n================================ */\n\n@media (max-width: 400px) {\n\n  .scada-kpi-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .scada-kpi-card {\n    height: 48px;\n  }\n\n  .scada-kpi-title {\n    font-size: 8px;\n  }\n\n  .scada-kpi-value {\n    font-size: 15px;\n  }\n\n  .scada-title h6 {\n    font-size: 11px;\n  }\n\n  .scada-title h6:last-child {\n    font-size: 10px;\n  }\n\n  .main-table th,\n  .main-table td {\n    font-size: 10px;\n    padding: 6px;\n  }\n}\n\n/* ================================\n   SCROLLBAR\n================================ */\n\n.scada-table-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.scada-table-wrapper::-webkit-scrollbar-track {\n  background: #e5e7eb;\n  border-radius: 10px;\n}\n\n.scada-table-wrapper::-webkit-scrollbar-thumb {\n  background: #0f6d86;\n  border-radius: 10px;\n}\n\n.scada-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #0b5f68;\n}\n\n\n/*  CODE FOR  BOTTOM LAYERS */\n\n\n\n\n\n\n\n\n\n\n.dashboardWTP {\n  position: relative;\n  padding-top: 20px;;\n  z-index: 1;\n  height:90vh;\n  display: grid;\n  grid-template-rows: 78px 1fr;\n}\n\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--border);\n  backdrop-filter: blur(20px);\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 310px;\n}\n\n.brand-icon {\n  width: 50px;\n  height: 50px;\n  display: grid;\n  place-items: center;\n  border-radius: 14px;\n\n  box-shadow: 0 0 30px rgba(34, 211, 238, 0.24);\n}\n\n.brand-icon svg,\n.mini-icon svg,\n.node-icon svg {\n  width: 40px;\n  height: 40px;\n  color: white;\n}\n\nh1 {\n  font-size: clamp(19px, 2.4vw, 29px);\n  line-height: 1.05;\n  letter-spacing: 0;\n}\n\n.subline {\n  color: var(--muted);\n  font-size: 13px;\n  margin-top: 6px;\n}\n\n.top-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.control1,\n.status-pill {\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  border: 1px solid var(--border);\n  background: rgba(6, 29, 52, 0.055);\n  border-radius: 8px;\n  color: var(--text);\n}\n\n.control1 {\n  position: relative;\n  padding: 0 14px;\n}\n\n.control1 svg,\n.status-pill svg {\n  width: 18px;\n  height: 18px;\n  color: var(--cyan);\n}\n\n.selectwtp {\n  min-width: 210px;\n  padding-right: 20px;\n  border: 0;\n  outline: 0;\n  appearance: none;\n  background: transparent;\n  color: var(--text);\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n\noption {\n  background: #9aa3ad;\n  color: var(--text);\n}\n\n.control1::after {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-right: 2px solid var(--muted);\n  border-bottom: 2px solid var(--muted);\n  transform: rotate(45deg);\n  position: absolute;\n  right: 14px;\n  top: 14px;\n  pointer-events: none;\n}\n\n.status-pill {\n  padding: 0 13px;\n  color: #c9edf8;\n  font-size: 13px;\n}\n\n.pulse {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--green);\n  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6);\n  animation: pulse 1.7s infinite;\n}\n\n.main {\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 288px minmax(620px, 1fr) 330px;\n  gap:0px;\n  padding: 0px;\n}\n\n.rail,\n.right-panel,\n.map-panel {\n  min-height: 0;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background:rgb(25, 34, 36);\n  backdrop-filter: blur(20px);\n  box-shadow: var(--shadow);\n}\n\n.rail,\n.right-panel {\n  overflow: auto;\n}\n\n\n\n.panel-title {\n  font-size: 13px;\n  color: #c7e8f5;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.tiny {\n  color: var(--muted);\n  font-size: 12px;\n}\n\n.kpis {\n  display: grid;\n  gap: 5px;\n  padding: 10px;\n}\n\n.kpi {\n  position: relative;\n  min-height:10px;\n  padding: 10px;\n  overflow: hidden;\n  border: 1px solid rgba(20, 23, 24, 0.12);\n  border-radius: 8px;\n  background:rgb(5, 34, 63);\n   \n}\n\n.kpi::after {\n  content: \"\";\n  position: absolute;\n  width:20px;\n  height: 110px;\n  right: -52px;\n  bottom: -56px;\n  border-radius: 50%;  \n background: color-mix(in srgb, var(--accent) 18%, transparent);\n}\n\n.kpi-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.mini-icon {\n  width: 34px;\n  height: 34px;\n  display: grid;\n  place-items: center;\n  flex: 0 0 auto;\n  border-radius: 8px;\n  color: var(--accent);\n  background: color-mix(in srgb, var(--accent) 13%, transparent);\n}\n\n.kpi-value {\n  margin-top: 12px;\n  font-size: 33px;\n  font-weight: 850;\n  letter-spacing: 0;\n}\n\n.kpi-caption {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 10px;\n  color: #a9c4d5;\n  font-size: 12px;\n}\n\n.trend {\n  color: var(--green);\n  font-weight: 800;\n}\n\n.system-box {\n  margin: 0 14px 14px;\n  padding: 14px;\n  border: 1px solid rgba(148, 219, 255, 0.12);\n  border-radius: 8px;\n  background: rgba(255,255,255,0.035);\n}\n\n.ring {\n  width: 138px;\n  height: 138px;\n  margin: 10px auto 8px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background:\n    conic-gradient(var(--green) 0deg, var(--cyan) var(--health-angle), rgba(255,255,255,0.08) 0deg),\n    radial-gradient(circle, rgba(7,16,24,1) 58%, transparent 59%);\n  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.08), 0 0 32px rgba(34, 211, 238, 0.12);\n}\n\n.ring-inner {\n  width: 98px;\n  height: 98px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: #0a1722;\n  border: 1px solid rgba(148, 219, 255, 0.12);\n  text-align: center;\n}\n\n.ring-value {\n  font-size: 27px;\n  font-weight: 850;\n}\n\n.ring-label {\n  color: var(--muted);\n  font-size: 11px;\n  margin-top: 3px;\n}\n\n.mini-bars {\n  display: grid;\n  gap: 9px;\n  margin-top: 12px;\n}\n\n.mini-bar {\n  display: grid;\n  grid-template-columns: 82px 1fr 38px;\n  align-items: center;\n  gap: 9px;\n  color: #bad4e3;\n  font-size: 12px;\n}\n\n.bar-track {\n  height: 8px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: rgba(255,255,255,0.08);\n}\n\n.bar-fill {\n  width: var(--w);\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, var(--blue), var(--teal));\n  animation: barBreathe 2.6s ease-in-out infinite;\n}\n\n.map-panel {\n  position: relative;\n  overflow: hidden;\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n}\n\n.map-toolbar {\n  min-height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid rgba(148, 219, 255, 0.12);\n}\n\n.map-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n}\n\n.map-title strong {\n  font-size: 16px;\n}\n\n.map-title span {\n  display: block;\n  margin-top: 3px;\n  color: var(--muted);\n  font-size: 12px;\n}\n\n.segmented {\n  display: inline-flex;\n  padding: 4px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: rgba(255,255,255,0.04);\n}\n\n.segment {\n  border: 0;\n  color: var(--muted);\n  background: transparent;\n  padding: 8px 11px;\n  border-radius: 6px;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.segment.active {\n  color: #071018;\n  background: linear-gradient(135deg, var(--cyan), var(--green));\n}\n\n.canvas-wrap {\n  position: relative;\n  overflow: auto;\n  scrollbar-color: rgba(56, 189, 248, 0.45) rgba(255,255,255,0.05);\n}\n\n.network {\n  position: relative;\n  min-width: 1320px;\n  min-height: 780px;\n  overflow: visible;\n  background:\n    linear-gradient(90deg, rgba(56, 189, 248, 0.045), transparent 31%, transparent 67%, rgba(251, 191, 36, 0.045)),\n    radial-gradient(circle at 50% 46%, rgba(34, 211, 238, 0.08), transparent 34rem);\n}\n\n.lane {\n  position: absolute;\n  top: 18px;\n  height: 28px;\n  padding: 6px 10px;\n  border: 1px solid rgba(148, 219, 255, 0.13);\n  border-radius: 999px;\n  color: #b9dceb;\n  background: rgba(255,255,255,0.045);\n  font-size: 11px;\n  font-weight: 850;\n  letter-spacing: 0.08em;\n}\n\n.lane-intake { left: 66px; }\n.lane-wtp { left: 528px; }\n.lane-oht { left: 1016px; }\n\n#svgCanvas {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  pointer-events: none;\n}\n\n.pipe-shadow {\n  fill: none;\n  stroke: rgba(0, 0, 0, 0.34);\n  stroke-width: 17;\n  stroke-linecap: round;\n}\n\n.pipe-base {\n  fill: none;\n  stroke: rgba(148, 219, 255, 0.16);\n  stroke-width: 9;\n  stroke-linecap: round;\n}\n\n.pipe-flow {\n  fill: none;\n  stroke: url(#pipeGradient);\n  stroke-width: 6;\n  stroke-linecap: round;\n  stroke-dasharray: 14 17;\n  animation: pipeFlow 0.76s linear infinite;\n  filter: drop-shadow(0 0 9px rgba(34, 211, 238, 0.62));\n}\n\n.drop {\n  fill: #e0faff;\n  stroke: #38bdf8;\n  stroke-width: 2;\n  filter: drop-shadow(0 0 10px rgba(34, 211, 238, 0.82));\n}\n\n.node {\n  position: absolute;\n  z-index: 4;\n  width: 188px;\n  min-height: 108px;\n  padding: 13px;\n  border: 1px solid rgba(148, 219, 255, 0.18);\n  border-top-color: color-mix(in srgb, var(--accent) 62%, white);\n  border-radius: 9px;\n  background:\n    linear-gradient(145deg, color-mix(in srgb, var(--accent) 12%, transparent), rgba(255,255,255,0.045)),\n    rgba(9, 22, 34, 0.92);\n  box-shadow: 0 18px 42px rgba(0,0,0,0.34);\n  overflow: hidden;\n  animation: nodeFloat 5s ease-in-out infinite;\n  transition: transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease;\n}\n\n.node::after {\n  content: \"\";\n  position: absolute;\n  width: 90px;\n  height: 90px;\n  right: -38px;\n  bottom: -42px;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--accent) 16%, transparent);\n}\n\n.node:hover {\n  transform: translateY(-6px);\n  border-color: color-mix(in srgb, var(--accent) 70%, white);\n  box-shadow: 0 26px 58px rgba(0,0,0,0.44), 0 0 22px color-mix(in srgb, var(--accent) 18%, transparent);\n}\n\n.node-main {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.node-icon {\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: 8px;\n  color: #06111a;\n  background: linear-gradient(135deg, var(--accent), color-mix(in srgb, var(--accent) 55%, white));\n  flex: 0 0 auto;\n}\n\n.node-name {\n  font-size: 15px;\n  font-weight: 850;\n  text-transform: uppercase;\n  letter-spacing: 0;\n}\n\n.node-type {\n  color: var(--muted);\n  margin-top: 3px;\n  font-size: 18px;\n  line-height: 1.35;\n  color:#b9dceb\n}\n\n.node-data {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.meter {\n  height: 7px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: rgba(255,255,255,0.1);\n}\n\n.meter span {\n  display: block;\n  height: 100%;\n  width: var(--level);\n  border-radius: inherit;\n  background: linear-gradient(90deg, var(--accent), #e0faff);\n  animation: barBreathe 2.4s ease-in-out infinite;\n}\n\n.flow-text {\n  color: #e6fbff;\n  font-size: 12px;\n  font-weight: 850;\n  white-space: nowrap;\n}\n\n.node-foot {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 10px;\n  color: var(--muted);\n  font-size: 11px;\n}\n\n.ok {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #a7f3d0;\n  font-weight: 800;\n}\n\n.ok::before {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--green);\n  box-shadow: 0 0 10px rgba(34, 197, 94, 0.8);\n}\n\n.intake { --accent: var(--blue); }\n.wtp { --accent: var(--teal); }\n.oht { --accent: var(--amber); }\n\n.flow-card {\n  position: absolute;\n  z-index: 6;\n  min-width: 92px;\n  padding: 7px 9px;\n  border: 1px solid rgba(56, 189, 248, 0.22);\n  border-radius: 8px;\n  background: rgba(4, 13, 22, 0.9);\n  box-shadow: 0 14px 30px rgba(0,0,0,0.28);\n  text-align: center;\n  animation: cardIn 360ms ease both;\n}\n\n.flow-card small {\n  display: block;\n  color: var(--muted);\n  font-size: 9px;\n  font-weight: 850;\n  letter-spacing: 0.08em;\n}\n\n.flow-card strong {\n  display: block;\n  color: var(--cyan);\n  margin-top: 2px;\n  font-size: 13px;\n}\n\n.map-footer {\n    min-height: 150px;\n  display: grid;\n\n}\n\n.footer-stat {\n  min-height: 74px;\n  padding: 12px 14px;\n  background: rgba(7, 16, 24, 0.72);\n}\n\n.footer-stat span {\n  color: var(--muted);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.footer-stat strong {\n  display: block;\n  margin-top: 6px;\n  font-size: 22px;\n}\n\n.alerts,\n.assets {\n  padding: 3px;\n  display: grid;\n  gap: 10px;\n}\n\n.alert {\n  display: grid;\n  grid-template-columns: 10px 1fr auto;\n  gap: 10px;\n  align-items: start;\n  padding: 12px;\n  border: 1px solid rgba(148, 219, 255, 0.12);\n  border-radius: 8px;\n  background: rgba(255,255,255,0.04);\n}\n\n.severity {\n  width: 10px;\n  height: 10px;\n  margin-top: 4px;\n  border-radius: 50%;\n  background: var(--sev);\n  box-shadow: 0 0 14px color-mix(in srgb, var(--sev) 75%, transparent);\n}\n\n.alert strong {\n  display: block;\n  font-size: 13px;\n}\n\n.alert span {\n  display: block;\n  margin-top: 3px;\n  color: var(--muted);\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.alert time {\n  color: #a9c4d5;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.asset {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 10px;\n  align-items: center;\n  padding: 11px 12px;\n  border: 1px solid rgba(148, 219, 255, 0.12);\n  border-radius: 8px;\n  background: rgba(255,255,255,0.035);\n}\n\n.asset strong {\n  font-size: 13px;\n}\n\n.asset span {\n  display: block;\n  margin-top: 3px;\n  color: var(--muted);\n  font-size: 12px;\n}\n\n.badge {\n  padding: 5px 8px;\n  border-radius: 999px;\n  color: #071018;\n  background: linear-gradient(135deg, var(--cyan), var(--green));\n  font-size: 11px;\n  font-weight: 850;\n}\n\n@keyframes scan {\n  from { transform: translateX(-130%); }\n  to { transform: translateX(130%); }\n}\n\n@keyframes pulse {\n  70% { box-shadow: 0 0 0 10px rgba(34, 197, 94, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }\n}\n\n@keyframes pipeFlow {\n  to { stroke-dashoffset: -31; }\n}\n\n@keyframes nodeFloat {\n  0%, 100% { translate: 0 0; }\n  50% { translate: 0 -4px; }\n}\n\n@keyframes barBreathe {\n  0%, 100% { opacity: 0.78; }\n  50% { opacity: 1; }\n}\n\n@keyframes cardIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width:900px) {\n  body {\n    overflow: auto;\n  }\n\n  .dashboardWTP {\n    min-height: 100vh;\n    height: auto;\n  }\n\n  .main {\n    grid-template-columns: 1fr;\n  }\n\n\n\n  .kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .map-panel {\n    min-height: 720px;\n  }\n}\n\n@media (max-width: 320px) {\n  .topbar {\n    align-items: flex-start;\n    flex-direction: column;\n    height: auto;\n  }\n\n  .brand {\n    min-width: 0;\n  }\n\n  .top-actions,\n  .control1 {\n    width: 100%;\n  }\n\n  selectwtp {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .dashboardWTP {\n    grid-template-rows: auto 1fr;\n  }\n\n  .kpis,\n  .map-footer {\n    grid-template-columns: 1fr;\n  }\n\n  .map-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n/* POPUP Graph  */\n.maximized-map-panel {\n  position: fixed !important;\n  top: 65%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: calc(90vw - 80px) !important;\n  height: calc(90vh - 80px) !important;\n  z-index: 999999;\n  border-radius: 20px;\n  border: 2px solid rgba(96,165,250,0.55);\n  background:\n    linear-gradient(\n      145deg,\n      rgba(0,0,0,0.96),\n      rgba(17,24,39,0.94),\n      rgba(31,41,55,0.92)\n    );\n\n  backdrop-filter: blur(12px);\n\n  overflow: auto;\n\n  padding:\n    60px   /* top */\n    20px   /* right */\n    20px   /* bottom */\n    20px;  /* left */\n\n  box-shadow:\n    0 0 0 2px rgba(59,130,246,0.15),\n    0 10px 40px rgba(0,0,0,0.55),\n    0 0 25px rgba(59,130,246,0.25);\n\n  animation: popupZoom 0.28s ease;\n}\n\n/* DARK OVERLAY */\n\n.maximized-map-panel::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.68);\n  z-index: -1;\n}\n\n/* POPUP ANIMATION */\n\n@keyframes popupZoom {\n\n  from {\n    opacity: 0;\n    transform:\n    translate(-50%, -50%)\n    scale(0.92);\n  }\n\n  to {\n    opacity: 1;\n    transform:\n    translate(-50%, -50%)\n    scale(1);\n  }\n}\n\n\n.custom-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  font-family: Arial, sans-serif;\n}\n\n/* HEADER */\n.custom-table thead tr {\n  background: linear-gradient(to right, #045e5a, #03816c);\n}\n\n.custom-table th {\n  color: #ffffff;\n  text-transform: uppercase;   /* ✅ CAPITAL */\n  letter-spacing: 0.5px;       /* ✅ spacing */\n  padding: 10px;\n  border: 1px solid #0f2a2e;\n  text-align: center;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n/* BODY */\n.custom-table td {\n  padding: 8px;\n  border: 1px solid #cfe8f3;\n  text-align: center;\n}\n\n/* ROW COLORS */\n.custom-table tbody tr:nth-child(even) {\n  background-color: #f0f9ff;\n}\n\n.custom-table tbody tr:nth-child(odd) {\n  background-color: #e0f2fe;\n}\n\n/* HOVER EFFECT */\n.custom-table tbody tr:hover {\n  background-color: #bae6fd;\n  transition: 0.2s ease;\n}\n\n/* NO DATA ROW */\n.custom-table td[colspan] {\n  text-align: center;\n  font-weight: bold;\n  padding: 15px;\n  color: #555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
